// @flow

import React, { memo, useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

const FloatingTempButton = (props: FloatingTempButton.propTypes) => {
  const rootRef = useRef();
  const hoverRef = useRef();

  const [shown, setShown] = useState(false);

  useEffect(() => {
    let container = rootRef.current.closest('div');
    hoverRef.current = container;

    let mouseEnterListener = (e) => {
      setShown(true);
    };

    let mouseLeaveListener = (e) => {
      setShown(false);
    };

    container.addEventListener('mouseenter', mouseEnterListener);
    container.addEventListener('mouseleave', mouseLeaveListener);

    // Remove event listener on cleanup
    return () => {
      container.removeEventListener('mouseenter', mouseEnterListener);
      container.removeEventListener('mouseleave', mouseLeaveListener);
    };
  }, [rootRef.current]);

  let style = {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 3,
  };

  if (props.position === 'top') {
    style.top = '25%';
    style.transform += ' translateY(-50%)';
  } else if (props.position === 'bottom') {
    style.bottom = '25%';
    style.transform += ' translateY(50%)';
  } else {
    style.top = '50%';
    style.transform += ' translateY(-50%)';
  }

  return (
    <span style={style} ref={rootRef}>
      <Zoom in={shown}>
        <Tooltip title={props.tooltip} placement={props.tooltipPosition}>
          <Fab size="small" onClick={props.onClick}>
            <Box
              sx={{
                color: props.iconColor,
              }}
            >
              {props.icon}
            </Box>
          </Fab>
        </Tooltip>
      </Zoom>
    </span>
  );
};

FloatingTempButton.propTypes = {
  icon: PropTypes.any,
  iconColor: PropTypes.any,
  tooltip: PropTypes.any,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(['top', 'bottom']),
  tooltipPosition: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top',
  ]),
};

export default memo(FloatingTempButton);
